import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PasswordMask from 'components/components/common/PasswordMask';
import GoogleAuth from './GoogleAuth';
import FacebookAuth from './FacebookAuth';
import axios from 'components/AppRequest';
import originAxios from 'axios';
import { Error } from 'components/common/Form.js';
import withRouter from 'components/components/common/withRouter';
import { setUserLogged } from 'components/actions/authActions';
import { connect } from 'react-redux';
import LoadingSpinner from '../common/LoadingSpinner';
import isEmpty from 'lodash/isEmpty';
import LocalStorageHelper from 'components/common/helpers/LocalStorageHelper';
import mergeErrors from 'components/helpers/mergeErrors';
import InputPhoneNr from 'components/components/common/forms/InputPhoneNr';
import {
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

function SampleEyeShow() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye']}
      title="Show"
    />
  );
}

function SampleEyeHide() {
  return (
    <FontAwesomeIcon
      icon={['fas', 'eye-slash']}
      title="Hide"
    />
  );
}

class LoginPage extends Component {

  constructor(props) {
    super(props);
    this.inputPhoneRef = React.createRef();
  }

  state = {
    selectedOption: { value: "norway", label: "+47", code: "NO" },
    phoneNumber: '',
    password: '',
    bg: true,
    errors: {},
    isLoading: false
  }

  trans = (key, prefix = 'content.auth.loginPage') => {
    return TransHelper.translate(this.props.locale, prefix + '.' + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.loginPage');
  }

  handleChange = (selectedOption) => {
    this.setState({ selectedOption });
    console.log('Option selected:', selectedOption);
  }

  formSubmit = (e) => {
    e.preventDefault();

    this.setState({ isLoading: true, errors: {} }, () => {
      if (this.isFormValid()) {
        //login
        var wholePhone = this.state.selectedOption.label + this.state.phoneNumber;
        var params = { username: wholePhone, password: this.state.password };
        axios.post('/pwa/security/login', params)
          .then(response => {
            originAxios.post('/set-logged');
            LocalStorageHelper.saveToken(response.data.token);
            this.props.setUserLogged(response.data);
            TransHelper.redirect(this.props, 'routes.url.dashboard');
          })
          .catch(err => {
            console.log("err", err)
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: mergeErrors(err.response.data.error)
            });
            this.setState({ isLoading: false });
          });
      } else {
        //show errors
        this.setState({ errors: this.getFormErrors(), isLoading: false });
      }
    });
  }

  handlePasswordChange = (e) => {
    this.setState({ password: e.target.value });
  }

  handlePhoneChange = (value) => {
    this.setState({ phoneNumber: value });
  }

  isFormValid = () => {
    var errors = this.getFormErrors();
    return isEmpty(errors);
  }

  getFormErrors = () => {
    var hash = {};
    if (this.state.password.length === 0) {
      hash['password'] = this.trans('passwordBlank', 'content.errors.auth.loginPage');
    }

    if (this.inputPhoneRef.current.validateForm()) {
      hash['phone'] = this.inputPhoneRef.current.validateForm();
    }

    return hash;
  }

  handleSubmit = e => {
    e.preventDefault();
  }

  componentDidMount() {
    document.body.classList.add('login-bg');
  }

  render() {
    const { selectedOption, phoneNumber, password, isLoading } = this.state;
    return (
      <div className="layout layout--bg-bottom">
        <div className="wrapper">
          <div className="head mb-40">
            <h3>{this.trans('title')}</h3>
            <p>{this.trans('subtitle')}&nbsp;
              <FacebookAuth />
              &nbsp; {this.trans('authSeparator')}&nbsp;
              <GoogleAuth />
            </p>
          </div>

          <div className="content">
            <form onSubmit={this.formSubmit}>
              <fieldset>
                <legend className="visuallyhidden">Login Form</legend>
                <ul className="list-fields list-none mb-15">
                  <li className="list-fields__item">
                    <InputPhoneNr
                      ref={this.inputPhoneRef}
                      changePhoneCountry={this.handleChange}
                      changePhoneNumber={this.handlePhoneChange}
                      errorPhone={this.state.errors.phone}
                      phoneNumber={phoneNumber}
                      phoneCountry={selectedOption}
                      className="list-fields__phone-nr"
                      locale={this.props.locale}
                    />
                  </li>

                  <li className="list-fields__item">
                    <label htmlFor="password">{this.trans('passwordLabel')}</label>
                    <PasswordMask
                      id="password"
                      name="password"
                      value={password}
                      onChange={this.handlePasswordChange}
                      showButtonContent={<SampleEyeShow />}
                      hideButtonContent={<SampleEyeHide />}
                      buttonClassName="button--toggle"
                      className="button-toggle-wrap"
                    />
                    <Error error={this.state.errors.password} />
                  </li>
                </ul>

                <p className="text-right text-small mb-30">
                  <AppLink to="routes.url.resetPassword">
                    {this.trans('forgotPassword')}
                  </AppLink>
                </p>

                {isLoading
                  ?
                  <LoadingSpinner className="button button--expand" />
                  :
                  <button type="submit" className="button button--expand">{this.trans('logIn')}</button>
                }
              </fieldset>
            </form>

            <div className="footer-bottons">
              <p className="text-center">{this.trans('accountInfo')}</p>
              <p className="text-center">
                <AppLink to="routes.url.signup">{this.trans('createAccount')}</AppLink>
              </p>
            </div>
          </div>
        </div>

        <footer className="footer">
        </footer>

      </div>

    );
  }
}

export default withRouter(
  connect(
    null,
    { setUserLogged, createErrorNotification }
  )(LoginPage));
